import { render, staticRenderFns } from "./process_p.vue?vue&type=template&id=6151e981&scoped=true"
import script from "./process_p.vue?vue&type=script&lang=js"
export * from "./process_p.vue?vue&type=script&lang=js"
import style0 from "./process_p.vue?vue&type=style&index=0&id=6151e981&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151e981",
  null
  
)

export default component.exports